import Vue from 'vue'
import types from '../mutations/mutation-types'
import { MenuActions } from '../actions/'

export default {
  state: {
    menus: [],
    smsapps: [],
    menuOptions: [],
    aMenu: {
      name: '',
      gender: '',
      message: '',
      swahili: ''
    }
  },
  mutations: {
    [types.MENU.GET_ALL_MENUS] (state, allMenus) {
      state.menus = allMenus
    },
    [types.MENU.SET_APPS] (state, apps) {
      state.smsapps = apps
    },
    [types.MENU.ADD_MENU_OPTION] (state, option) {
      state.menuOptions.push(option)
    },
    [types.MENU.REMOVE_MENU_OPTION] (state, index) {
      state.menuOptions.splice(index, 1)
    },
    [types.MENU.UPDATE_MENU_FIELD] (state, { value, key }) {
      Vue.set(state.aMenu, key, value)
    },
    [types.MENU.SET_A_MENU] (state, { details, options }) {
      state.aMenu = details
      state.menuOptions = [...options]
    },
    [types.MENU.ADD_MENU] (state, details) {
      state.menus.push(details)
      state.aMenu = {
        name: '',
        gender: '',
        message: '',
        swahili: ''
      }
      state.menuOptions = []
    },
    [types.MENU.EDIT_MENU] (state, { id, details }) {
      const key = state.menus.findIndex(each => each._id === id)
      if (key >= 0) {
        Vue.set(state.menus, key, details)
      }
      state.aMenu = {
        name: '',
        gender: '',
        message: '',
        swahili: ''
      }
      state.menuOptions = []
    },
    [types.MENU.EDIT_MENU_OPTION] (state, { option, index }) {
      Vue.set(state.menuOptions, index, option)
    }
  },
  actions: MenuActions,
  getters: {
    getSmsApps: state => state.smsapps
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/menu.js